/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

export const GuideImage1 = ( props ) => (
	<>
		<img
			className="redux-edit-post-welcome-guide__image redux-edit-post-welcome-guide__image__prm-np"
			alt=""
			src={ `${ redux_templates.plugin }assets/img/welcome-guide-1.png` }
			{ ...props }
		/>
	</>
);

export const GuideImage2 = ( props ) => (
	<>
		<img
			className="redux-edit-post-welcome-guide__image redux-edit-post-welcome-guide__image__prm-np"
			alt=""
			src={ `${ redux_templates.plugin }assets/img/welcome-guide-2.gif` }
			{ ...props }
		/>
	</>
);
export const GuideImage3 = ( props ) => (
	<>
		<img
			className="redux-edit-post-welcome-guide__image redux-edit-post-welcome-guide__image__prm-np"
			alt=""
			src={ `${ redux_templates.plugin }assets/img/welcome-guide-3.png` }
			{ ...props }
		/>
	</>
);
